import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AfterViewInit } from '@angular/core';
import { ViewChild } from '@angular/core';
import { Input } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'app-meeting-intro',
    templateUrl: './meeting-intro.component.html',
    styleUrls: ['./meeting-intro.component.scss']
})
export class MeetingIntroComponent implements OnInit, AfterViewInit {

    constructor(private modalService: NgbModal) {
    }

    @ViewChild('content')
    content: any;

    @ViewChild('step1')
    step1;

    @ViewChild('step2')
    step2;

    @ViewChild('step3')
    step3;

    selectedStep: any;
    dontShow: boolean = false;

    @Input()
    $open: Observable<boolean>;


    step = 1;

    ngOnInit(): void {
        this.dontShow = localStorage.getItem("introShow") === 'false';
    }

    ngAfterViewInit(): void {
        this.selectedStep = this.step1;
        this.$open.subscribe((open) => {
            if (open) {
                this.modalService.open(this.content, {centered: true, size: 'xl', windowClass: 'intro'});
            }
        })

    }

    changeStep(direction) {
        if (direction < 0) {
            this.step--;
        } else {
            this.step++;
        }

        if (this.step === 1) {
            this.selectedStep = this.step1;
        } else if (this.step === 2) {
            this.selectedStep = this.step2;
        } else if (this.step === 3) {
            this.selectedStep = this.step3;
        }
    }

    closeModal() {
        localStorage.setItem("introShow", String(!this.dontShow));
        this.modalService.dismissAll();
    }


}
